export function normalizeToCamelCase<T extends object>(
	data: T,
): T extends Record<string, any> ? Record<string, any> : T {
	return JSON.parse(
		JSON.stringify(data).replace(/"\w+":/g, (keys) =>
			keys.replace(/_\w/g, (letters) => letters[1]?.toUpperCase() ?? letters),
		),
	);
}

export function normalizeToSnakeCase<T extends object>(
	data: T,
): T extends Record<string, any> ? Record<string, any> : T {
	return JSON.parse(
		JSON.stringify(data).replace(/"\w+":/g, (keys) =>
			keys.replace(/[A-Z]/g, (letters) => `_${letters.toLowerCase()}`),
		),
	);
}
